import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import LessonsPage from "@/pages/LessonsPage";
import AssignmentsPage from "@/pages/AssignmentsPage";
import PmoAiPlan from "@/pages/pmo/PmoAiPlan";
import PmoExecSummary from "@/pages/pmo/PmoExecSummary";
import PmoArchived from "@/pages/pmo/PmoArchived";
import PmoRegistry from "@/pages/pmo/PmoRegistry";
import PmoArtifacts from "@/pages/pmo/PmoArtifacts";
import PmoProcess from "@/pages/pmo/PmoProcess";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Landing from "@/pages/Landing";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Dashboard from "@/pages/Dashboard";
import DashboardHome from "@/pages/DashboardHome";
import Portfolio from "@/pages/Portfolio";
import CardsPage from "@/pages/CardsPage";
import SpacesPage from "@/pages/SpacesPage";
import MyCard from "@/pages/MyCard";
import Guide from "@/pages/Guide";
import WhatsNew from "@/pages/WhatsNew";
import Billing from "@/pages/Billing";
import StatusReport from "@/pages/StatusReport";
import PmoPage from "@/pages/PmoPage";
import BuildEol from "@/pages/BuildEol";
import LibraryPage from "@/pages/LibraryPage";
import SharedProcess from "@/pages/SharedProcess";
import ProjectDetail from "@/pages/ProjectDetail";
import PublicStatusReport from "@/pages/PublicStatusReport";
import ActionCheckoff from "@/pages/ActionCheckoff";
import ApprovalPage from "@/pages/ApprovalPage";
import AcceptInvite from "@/pages/AcceptInvite";
import AdminDashboard from "@/pages/AdminDashboard";
import AuditPage from "@/pages/AuditPage";
import ViewRedirect from "@/pages/ViewRedirect";
import FeedbackWidget from "@/components/FeedbackWidget";
import PMAssistant from "@/components/PMAssistant";
import DemoShowcase from "@/pages/DemoShowcase";
import ServerWakeOverlay from "@/components/ServerWakeOverlay";
import NdaGate from "@/components/NdaGate";
import DemoTour from "@/components/DemoTour";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/" element={<Landing />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/welcome" element={<Landing />} />
            <Route path="/demo" element={<DemoShowcase key="journey" />} />
            <Route path="/demo/features" element={<DemoShowcase key="features" variant="features" />} />
            <Route path="/demo/highlights" element={<DemoShowcase key="highlights" variant="highlights" />} />
            <Route path="/demo/pmo" element={<DemoShowcase key="pmo" variant="pmo" />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/home" element={<ProtectedRoute><DashboardHome /></ProtectedRoute>} />
            <Route path="/portfolio" element={<ProtectedRoute><Portfolio /></ProtectedRoute>} />
            <Route path="/pmo" element={<ProtectedRoute><PmoPage /></ProtectedRoute>} />
            <Route path="/pmo/ai-plan" element={<ProtectedRoute><PmoAiPlan /></ProtectedRoute>} />
            <Route path="/pmo/exec-summary" element={<ProtectedRoute><PmoExecSummary /></ProtectedRoute>} />
            <Route path="/pmo/archived" element={<ProtectedRoute><PmoArchived /></ProtectedRoute>} />
            <Route path="/pmo/registry" element={<ProtectedRoute><PmoRegistry /></ProtectedRoute>} />
            <Route path="/pmo/artifacts" element={<ProtectedRoute><PmoArtifacts /></ProtectedRoute>} />
            <Route path="/pmo/process" element={<ProtectedRoute><PmoProcess /></ProtectedRoute>} />
            <Route path="/lessons" element={<ProtectedRoute><LessonsPage /></ProtectedRoute>} />
            <Route path="/assignments" element={<ProtectedRoute><AssignmentsPage /></ProtectedRoute>} />
            <Route path="/cards" element={<ProtectedRoute><CardsPage /></ProtectedRoute>} />
            <Route path="/spaces" element={<ProtectedRoute><SpacesPage /></ProtectedRoute>} />
            <Route path="/guide" element={<ProtectedRoute><Guide /></ProtectedRoute>} />
            <Route path="/whats-new" element={<ProtectedRoute><WhatsNew /></ProtectedRoute>} />
            <Route path="/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
            <Route path="/status-report" element={<ProtectedRoute><StatusReport /></ProtectedRoute>} />
            <Route path="/build" element={<ProtectedRoute><BuildEol /></ProtectedRoute>} />
            <Route path="/build-eol" element={<ProtectedRoute><BuildEol /></ProtectedRoute>} />
            <Route path="/library" element={<ProtectedRoute><LibraryPage /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/audit" element={<ProtectedRoute><AuditPage /></ProtectedRoute>} />
            <Route path="/accept-invite/:token" element={<AcceptInvite />} />
            <Route path="/go/:tab" element={<ProtectedRoute><ViewRedirect /></ProtectedRoute>} />
            <Route path="/projects/:id" element={<ProtectedRoute><ProjectDetail /></ProtectedRoute>} />
            <Route path="/shared/report/:token" element={<PublicStatusReport />} />
            <Route path="/shared/process/:token" element={<SharedProcess />} />
            <Route path="/action/:token" element={<ActionCheckoff />} />
            <Route path="/approve/:token" element={<ApprovalPage />} />
            <Route path="/my-card/:token" element={<MyCard />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <DemoTour />
          <FeedbackWidget />
          <PMAssistant />
          <ServerWakeOverlay />
          <NdaGate />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
